import { PERIOD_TYPE, PRODUCT_CATEGORY } from "types/Post";
import { object, string, TypeOf, array, nativeEnum } from "zod";

export const createProductFormValidation = object({
  name: string({ required_error: "Nombre obligatorio" }).min(5, "Mínimo 5 caracteres"),
  description: string({ required_error: "Descripción obligatoria" }).min(10, "Mínimo 10 caracteres"),
  category: nativeEnum(PRODUCT_CATEGORY),
  price: string({ required_error: "Precio obligatorio" }),
  deposit: string({ required_error: "Fianza obligatoria" }),
  period: string({ required_error: "Periodo obligatorio" }).default(PERIOD_TYPE.MONTH),
  weight: string({ required_error: "Peso obligatorio" }),
  media: array(object({
    url: string().url("URL de imagen inválida"),
  })).max(5, "Máximo 5 imágenes"),
});

export type ICreateProductFormValidation = TypeOf<typeof createProductFormValidation>;
